import styled from 'styled-components';
import { SelectOptionsContainer, SelectWrapper } from 'ui/selects';
import {
  Body2,
  borderRadius,
  borderWidth1,
  colors,
  duration,
  easing,
  spacing,
  subtleShadow,
} from 'ui/theme';

export const ComboWrapper = styled.div<{ width?: string }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
  padding: ${spacing.single};
  gap: ${spacing.single};
  background-color: ${colors.backgroundPrimary};
  border: ${borderWidth1} ${colors.borderPrimary};
  box-shadow: ${subtleShadow.boxShadow};
  border-radius: ${borderRadius.lg};

  ${({ width }) => width && `width: ${width}`};

  &:hover {
    border: ${borderWidth1} ${colors.borderInteractive};
    transition: all ${duration.short} ${easing.entrance};
    background-color: ${colors.backgroundInteractive};
  }

  &:hover * {
    transition: all ${duration.short} ${easing.entrance};
    background-color: ${colors.backgroundInteractive};
  }

  &[data-select-align='right'] {
    flex-direction: row-reverse;
    justify-content: flex-end;
  }

  &[data-has-error='true'] {
    border: ${borderWidth1} ${colors.borderDestructive};
  }

  &[data-read-only='true'] {
    background-color: ${colors.backgroundSecondary};

    &:hover {
      cursor: not-allowed;
    }
  }

  &[data-input-focused='true'] {
    border-color: ${colors.borderInteractive};
    box-shadow: 0px 0px 0px 1px ${colors.borderInteractive};
  }

  .inputGhostWrapper {
    border: none;
    box-shadow: none;
    overflow: hidden;
    padding: 0;
    margin: ${spacing.half} ${spacing.threeQuarter};
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
`;

export const GhostSelectWrapper = styled(SelectWrapper)`
  border: none;
  box-shadow: none;
  border-radius: none;
  height: 100%;
`;

export const PrefixMask = styled(Body2)`
  color: ${colors.textDisabled};
  margin: 0;
`;

export const StyledSelectOptionsContainer = styled(SelectOptionsContainer)`
  * {
    scrollbar-width: auto; /* Firefox */
    overflow-x: hidden;
  }
  * [data-test='input-wrapper'] {
    overflow: hidden;
  }
`;
